import { render, staticRenderFns } from "./ThirdTypeRelationEditNew.vue?vue&type=template&id=1560b3c4&scoped=true"
import script from "./ThirdTypeRelationEditNew.vue?vue&type=script&lang=js"
export * from "./ThirdTypeRelationEditNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560b3c4",
  null
  
)

export default component.exports